import { render, staticRenderFns } from "./SGoodsPointe.vue?vue&type=template&id=8b1c0392&scoped=true"
import script from "./SGoodsPointe.vue?vue&type=script&lang=js"
export * from "./SGoodsPointe.vue?vue&type=script&lang=js"
import style0 from "./SGoodsPointe.vue?vue&type=style&index=0&id=8b1c0392&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1c0392",
  null
  
)

export default component.exports